/** The codelist resolving the ids behind the `carPark` filter and the vehicle's `carParkId` */
export const CAR_PARK_CODELIST_ID = 'carPark';
